import { Link } from "@/components/common/Link";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
import { Button } from "@/components/ui/button";
import { Facebook, Linkedin, Mail, Phone, MapPin } from "lucide-react";
export default function FooterInfoContact() {
  return <footer style={{
    backgroundColor: 'rgb(34, 34, 34)',
    backgroundPosition: '0% 0%',
    backgroundRepeat: 'repeat',
    color: 'rgb(102, 102, 102)',
    fontFamily: '"Open Sans", Arial, sans-serif'
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500;600;700&display=swap');
        @keyframes fadeIn {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }
        @keyframes fadeInTop {
          0% { opacity: 0; transform: translateY(-60%); }
          100% { opacity: 1; transform: translateY(0px); }
        }
        .footer-link {
          color: rgb(255, 255, 255);
          text-decoration: none;
          transition: opacity 0.3s;
        }
        .footer-link:hover {
          opacity: 0.75;
        }
        .enquiry-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #000000 !important;
          background-color: #E2E600 !important;
          border-radius: 100px;
          border: 3px solid rgb(255, 255, 255);
          font-size: 16px;
          font-weight: 600;
          font-family: "Open Sans", Arial, sans-serif;
          text-decoration: none;
          width: 95px;
          height: 95px;
          text-align: center;
          transition: opacity 0.3s;
          line-height: 1.2;
          padding: 0;
          white-space: normal;
        }
        .enquiry-btn:hover {
          opacity: 0.85;
        }
        .social-icon-circle {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background-color: rgb(50, 50, 50);
          transition: background-color 0.3s;
          text-decoration: none;
          color: white;
        }
        .social-icon-circle:hover {
          background-color: rgb(70, 70, 70);
        }
        .footer-bottom-link {
          color: rgb(206, 196, 78);
          text-decoration: none;
          transition: color 0.4s ease-in-out;
        }
        .footer-bottom-link:hover {
          color: rgb(255, 245, 100);
        }
      `}</style>

      <div style={{
      paddingTop: '40px',
      paddingBottom: '40px'
    }} className="!bg-[rgba(255,255,255,1)]">
        <div className="page-container">
          <div className="flex flex-col gap-12 !justify-center !items-center md:flex-row">
            
            <div className="flex flex-col gap-6 max-w-xs">
              <Link to="/">
                <WvcLogo className="h-12 w-auto" />
              </Link>
              
            </div>

            

            

          </div>
        </div>
      </div>

      <div style={{
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
      padding: '20px 0px'
    }} className="!bg-[rgba(255,255,255,1)] border-t border-gray-100">
        <div className="page-container">
          
        </div>
      </div>
    </footer>;
}